import { useTranslation } from 'react-i18next';
import logo from '@/assets/images/logo.svg';
import cars from '@/assets/images/hero/hero_cars.webp';
import carsMobile from '@/assets/images/hero/hero_cars_360.webp';

import { useScreenType } from '@/hooks/useScreenType';
import { useModal } from '@/hooks/useModal';

import { Container } from '@/components/Container';
import { Title } from '@/components/Title';
import { Button } from '@/components/Button';

import styles from './Hero.module.scss';

export function Hero() {
  const { t } = useTranslation('hero');
  const { screenType } = useScreenType();
  const { openModal } = useModal();

  const handleOrderClick = () => {
    openModal('order');
  };

  return (
    <section className={styles.hero}>
      <Container className={styles.hero__container}>
        <div className={styles.hero__content}>
          <div className={styles.hero__text}>
            <Title className={styles.hero__title}>{t('title')}</Title>
            <p className={styles.hero__description}>
              {t('description1')}
              {screenType === 'mobile' ? ' ' : <br />}
              {t('description2')}
            </p>
          </div>
          <Button onClick={handleOrderClick}>{t('button')}</Button>
        </div>
        <div className={styles.hero__logo}>
          <img src={logo} alt="Logo" />
        </div>
        <div className={styles.hero__cars}>
          <img src={screenType === 'mobile' ? carsMobile : cars} alt="Cars" />
        </div>
      </Container>
    </section>
  );
}
